import { FeatureLayersMappingService } from "./featureLayersMapping.service";
import { api } from "../../apiProvider";

export const featureLayersMappingAdapter: FeatureLayersMappingService = async () => {
    const resp = await api.featureLayersMapping();
    return resp.data;
};
